function truncate(text: string | undefined, maxNumberOfLetters: number) {
  return text && text.length > 30 ? `${text.slice(0, maxNumberOfLetters)}...` : text
}

export default truncate
